import {
  AppstoreOutlined,
  ArrowLeftOutlined,
  RightOutlined
} from "@ant-design/icons";
import Container from "components/container";
import * as appRoutes from "config/routes.config";
import { FC, useEffect, useState } from "react";

//!STYLES
import { Breadcrumb, Col, Row, Segmented, Tooltip } from "antd";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import s from "./assets/breadcrumbs.module.css";

//!IMAGES
import Gamification from "../../assets/images/app/gamification.svg";
import students from "../../assets/images/app/iam_student.svg";
import Teacher from "./assets/images/TeacherSvg.svg";
import Ads from "./assets/images/ads.svg";
import Calendrier from "./assets/images/calendar.svg";
import Classes from "./assets/images/classes.svg";
import Content from "./assets/images/contenu.svg";
import Dashboard from "./assets/images/dashboard.svg";
import SearchProf from "./assets/images/prof.svg";
import Wallet from "./assets/images/wallet.svg";

import { UserRoles } from "common/enums";
import { useSelector } from "react-redux";
import ArrowDown from "../../assets/images/app/arrow_bottom_down.svg";
import ArrowRight from "../../assets/images/app/arrow_right.svg";
import HomeIcon from "../../assets/images/app/home_icon.svg";
import Cours from "../../assets/images/teacher/cours.svg";
import Exo from "../../assets/images/teacher/exo.svg";
import Quiz from "../../assets/images/teacher/quiz.svg";
import { ReactComponent as ListIcon } from "./assets/images/list.svg";

type Props = {
  isMycontent?: boolean;
  isDashboard?: boolean;
  isCreateCourse?: boolean;
  isCreateQuiz?: boolean;
  isCreateExo?: boolean;
  isAds?: boolean;
  isRooms?: boolean;
  isBack?: boolean;
  pathBack?: string;
  title?: string;
  isSearchProf?: boolean;
  isProfil?: boolean;
  isCalendar?: boolean;
  isStudents?: boolean;
  isClassroom?: boolean;
  isTeachers?: boolean;
  isWallet?: boolean;
  isFAQ?: boolean;
  setSeeDetails?: React.Dispatch<React.SetStateAction<boolean>>;
  seeDetails?: boolean;
  actorFAQ?: string;
  categoryFAQ?: string;
  dataFAQ?: any;
  setCategoryData?: React.Dispatch<React.SetStateAction<any>>;
  setCategoryDetailQuestion?: React.Dispatch<React.SetStateAction<any>>;
  setCategoryDetailAnswer?: React.Dispatch<React.SetStateAction<any>>;
  setCategoryFAQ?: React.Dispatch<React.SetStateAction<any>>;
  setSelectedquestion?: React.Dispatch<React.SetStateAction<any>>;
  isGamification?: boolean;
};

const Breadcrumbs: FC<Props> = ({
  title,
  isMycontent,
  isDashboard,
  isCreateCourse,
  isCreateQuiz,
  isCreateExo,
  isAds,
  isBack,
  pathBack,
  isRooms,
  isSearchProf,
  isProfil,
  isCalendar,
  isStudents,
  isClassroom,
  isTeachers,
  isWallet,
  isFAQ,
  setSeeDetails,
  seeDetails,
  actorFAQ,
  categoryFAQ,
  dataFAQ,
  setCategoryData,
  setCategoryDetailQuestion,
  setCategoryDetailAnswer,
  setCategoryFAQ,
  setSelectedquestion,
  isGamification,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id, level } = useParams<any>();
  const { user } = useSelector((state) => state.auth);
  const isTeacher = user?.roles?.includes(UserRoles.TEACHER);
  const isStudent = user?.roles?.includes(UserRoles.STUDENT);
  const isParent = user?.roles?.includes(UserRoles.PARENT);
  const [router, setRouter] = useState<any>(null);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1050);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 1050);
  };
  window.addEventListener('resize', handleResize);

  const [seeCategories, setSeeCategories] = useState<boolean>(true);

  useEffect(() => {
    setRouter(window.location.pathname);
  }, [router]);

  return (
    <div className={s.breadcrumbs}>
      {isTeacher ? <Container>
        {user?.step === "completed" && <Row justify="space-between">
          <Col>
            <Breadcrumb
              style={{ lineHeight: "40px" }}
              separator={
                <span className={s.arrow}>
                  <RightOutlined color="#64B7AF" />
                </span>
              }
            >
              {!isMobile && <Breadcrumb.Item
                onClick={() => {
                  if (user?.roles.includes(UserRoles.TEACHER)) {
                    user?.step === "completed" ? navigate(appRoutes.TEACHER_DASHBOARD) : navigate(appRoutes.COMPLETE_PROFILE);
                  } else if (user?.roles.includes(UserRoles.STUDENT)) {
                    navigate(appRoutes.STUDENT_DASHBOARD);
                  } else {
                    navigate(appRoutes.HOME);
                  }
                }}
                className={s.__item}
              >
                <img src={HomeIcon} height={15} style={{ position: "relative", top: "-2px" }} />
              </Breadcrumb.Item>}

              {isStudents && (
                <Breadcrumb.Item className={s.__item}>
                  <img src={students} alt="" width={25} />{" "}
                  <span>Mes élèves</span>
                </Breadcrumb.Item>
              )}

              {!isMobile && isMycontent && (
                <Breadcrumb.Item className={s.__item}>
                  <img src={Content} alt="" width={25} />{" "}
                  <span>Mon contenu</span>
                </Breadcrumb.Item>
              )}

              {isDashboard && (
                <Breadcrumb.Item className={s.__item}>
                  <img src={Dashboard} alt="" width={25} />{" "}
                  <span>Mon Dashboard</span>
                </Breadcrumb.Item>
              )}

              {isCreateCourse && (
                <Breadcrumb.Item className={s.__item}>
                  <img src={Cours} alt="" width={25} />{" "}
                  <span>Créer un cours</span>
                </Breadcrumb.Item>
              )}

              {isCreateQuiz && (
                <Breadcrumb.Item className={s.__item}>
                  <img src={Quiz} alt="" width={25} />{" "}
                  <span>Créer un quiz</span>
                </Breadcrumb.Item>
              )}

              {isCreateExo && (
                <Breadcrumb.Item className={s.__item}>
                  <img src={Exo} alt="" width={15} />{" "}
                  <span>Créer un exercice</span>
                </Breadcrumb.Item>
              )}

              {isAds && (
                <Breadcrumb.Item className={s.__item}>
                  <img src={Ads} alt="" width={25} /> <span>Accueil</span>
                </Breadcrumb.Item>
              )}

              {isRooms && (
                <Breadcrumb.Item className={s.__item}>
                  <img src={Classes} alt="" width={25} />{" "}
                  <span>Mes classes</span>
                </Breadcrumb.Item>
              )}

              {isSearchProf && (
                <Breadcrumb.Item className={s.__item}>
                  <img
                    src={SearchProf}
                    alt=""
                    width={18}
                    style={{ position: "relative", top: "-2px" }}
                  />{" "}
                  <span>Trouver un prof</span>
                </Breadcrumb.Item>
              )}

              {isProfil && (
                <Breadcrumb.Item className={s.__item}>
                  <img src={Teacher} alt="" width={25} />{" "}
                  <span>Mon Profil</span>
                </Breadcrumb.Item>
              )}

              {isCalendar && (
                <Breadcrumb.Item className={s.__item}>
                  <img src={Calendrier} alt="" width={25} />{" "}
                  <span>Calendrier</span>
                </Breadcrumb.Item>
              )}

              {isFAQ && (
                <Breadcrumb.Item className={s.__item}>
                  <span>Centre d’aide</span>
                  {seeDetails && <span>
                    <img src={ArrowRight} height={isMobile ? 10 : 15} style={{ marginRight: "5px", marginLeft: "5px" }}></img>
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => { setSeeDetails?.(false); /* setSeeCategories(!seeCategories) */ }}
                    >
                      {actorFAQ}
                    </span>
                  </span>}
                  {seeDetails && <span /* onClick={() => setSeeCategories(!seeCategories)} */ style={{ color: "#7FB1B2" }}>
                    <img src={ArrowRight} height={isMobile ? 10 : 15} style={{ marginRight: "5px", marginLeft: "5px" }}></img>
                    {categoryFAQ}
                    {seeCategories && <img src={ArrowDown} height={isMobile ? 10 : 15} style={{ marginRight: "5px", marginLeft: "5px" }}></img>}
                  </span>}
                  {/* {seeDetails && seeCategories && <span>
                    {dataFAQ.length !== 1 && <div className={s.categoryBox}>
                      {dataFAQ && dataFAQ.filter((category: any) => category.title !== categoryFAQ).map((category: any, index: any) => (
                        <div
                          className={s.categoryText}
                          key={index}
                          onClick={() => {
                            setSeeDetails?.(true);
                            setCategoryData?.(category.data);
                            setCategoryDetailQuestion?.(category.data?.[0]?.question);
                            setCategoryDetailAnswer?.(category.data?.[0]?.answer);
                            setCategoryFAQ?.(category.title);
                            setSelectedquestion?.(0);
                            setSeeCategories(!seeCategories);
                          }}
                        >
                          {category.title}
                        </div>
                      ))}
                    </div>}
                  </span>} */}
                </Breadcrumb.Item>
              )}

              {isGamification && (
                <Breadcrumb.Item className={s.__item}>
                  <img src={Gamification} alt="" width={25} />{" "}
                  <span>Gamification</span>
                </Breadcrumb.Item>
              )}

              {/* <Breadcrumb.Item
                className={s.__item}
                onClick={() => navigate(-1)}
              >
                <span>Page précédente</span>
              </Breadcrumb.Item> */}
            </Breadcrumb>
          </Col>

          <Col>
            <Row gutter={12}>
              {isBack && (
                <Col>
                  <Breadcrumb
                    style={{ lineHeight: "40px" }}
                    separator={
                      <span className={s.arrow}>
                        <RightOutlined color="#64B7AF" />
                      </span>
                    }
                  >
                    {!isProfil && <Breadcrumb.Item
                      className={s.__item}
                      onClick={() => {
                        pathBack ? navigate(pathBack) : navigate(-1);
                      }}
                    >
                      <span>
                        {" "}
                        <ArrowLeftOutlined
                          style={{ position: "relative", top: "1px" }}
                        />{" "}
                        {pathBack ? "Retour aux chapitres" : "Page précédente"}
                      </span>
                    </Breadcrumb.Item>}
                  </Breadcrumb>
                </Col>
              )}

              {isMycontent && (
                isTeacher && <Col>
                  {user?.isActive && user?.step === "completed" ? (
                    <Segmented
                      style={{
                        background: "#80B1B2",
                        borderRadius: "20px",
                        padding: "0.4em",
                      }}
                      defaultValue={
                        location.pathname === appRoutes.TEACHER_COURSES
                          ? "Contributeur"
                          : location.pathname === appRoutes.TEACHER_QUIZZ
                            ? "Contributeur"
                            : location.pathname === appRoutes.TEACHER_EXERCICES
                              ? "Contributeur"
                              : "Explorateur"
                      }
                      onChange={(event) => {
                        if (event === "Contributeur") {
                          navigate(appRoutes.TEACHER_COURSES);
                        }
                        if (event === "Explorateur") {
                          navigate(appRoutes.COURSESBYLEVELS);
                        }
                      }}
                      options={[
                        {
                          label: "",
                          value: "Explorateur",
                          icon: <Tooltip title={"Mode Explorateur"} placement="bottom"><AppstoreOutlined /></Tooltip>,
                        },
                        {
                          label: (
                            <Tooltip title={"Mode Contributeur"} placement="bottom">
                              {" "}
                              <ListIcon
                                style={{
                                  position: "relative",
                                  width: "15px",
                                  height: "15px",
                                  top: "2.5px",

                                  display: "inline",
                                }}
                              />{" "}
                            </Tooltip>
                          ),
                          value: "Contributeur",
                        }
                      ]}
                    />
                  ) : <Segmented
                    style={{
                      background: "#80B1B2",
                      borderRadius: "20px",
                      padding: "0.4em",
                    }}
                    defaultValue={"Explorateur"}
                    options={[
                      {
                        label: "",
                        value: "Explorateur",
                        icon: <Tooltip title={"Mode Explorateur"} placement="bottom"><AppstoreOutlined /></Tooltip>,
                      },
                    ]}
                  />}
                </Col>
              )}
            </Row>
          </Col>
        </Row>}
      </Container> : isStudent ? <Container>
        <Row justify="space-between">
          <Col>
            <Breadcrumb
              style={{ lineHeight: "40px" }}
              separator={
                <span className={s.arrow}>
                  <RightOutlined color="#64B7AF" />
                </span>
              }
            >
              <Breadcrumb.Item
                onClick={() => {
                  if (user?.roles.includes(UserRoles.TEACHER)) {
                    user?.step === "completed" ? navigate(appRoutes.TEACHER_DASHBOARD) : navigate(appRoutes.COMPLETE_PROFILE);
                  } else if (user?.roles.includes(UserRoles.STUDENT)) {
                    navigate(appRoutes.STUDENT_DASHBOARD);
                  } else {
                    navigate(appRoutes.HOME);
                  }
                }}
                className={s.__item}
              >
                <img src={HomeIcon} height={15} style={{ position: "relative", top: "-2px" }} />
              </Breadcrumb.Item>

              {isMycontent && (
                <Breadcrumb.Item className={s.__item}>
                  <img src={Content} alt="" width={25} />{" "}
                  <span>Je m'entraine</span>
                </Breadcrumb.Item>
              )}

              {isDashboard && (
                <Breadcrumb.Item className={s.__item}>
                  <img src={Dashboard} alt="" width={25} />{" "}
                  <span>Mon Dashboard</span>
                </Breadcrumb.Item>
              )}

              {isCreateCourse && (
                <Breadcrumb.Item className={s.__item}>
                  <img src={Cours} alt="" width={25} />{" "}
                  <span>Créer un cours</span>
                </Breadcrumb.Item>
              )}

              {isCreateQuiz && (
                <Breadcrumb.Item className={s.__item}>
                  <img src={Quiz} alt="" width={25} />{" "}
                  <span>Créer un quiz</span>
                </Breadcrumb.Item>
              )}

              {isCreateExo && (
                <Breadcrumb.Item className={s.__item}>
                  <img src={Exo} alt="" width={15} />{" "}
                  <span>Créer un exercice</span>
                </Breadcrumb.Item>
              )}

              {isAds && (
                <Breadcrumb.Item className={s.__item}>
                  <img src={Ads} alt="" width={25} /> <span>Accueil</span>
                </Breadcrumb.Item>
              )}

              {isRooms && (
                <Breadcrumb.Item className={s.__item}>
                  <img src={Classes} alt="" width={25} />{" "}
                  <span>Mes classes</span>
                </Breadcrumb.Item>
              )}

              {isSearchProf && (
                <Breadcrumb.Item className={s.__item}>
                  <img
                    src={SearchProf}
                    alt=""
                    width={18}
                    style={{ position: "relative", top: "-2px" }}
                  />{" "}
                  <span>Trouver un prof</span>
                </Breadcrumb.Item>
              )}

              {isProfil && (
                <Breadcrumb.Item className={s.__item}>
                  <img src={Classes} alt="" width={25} />{" "}
                  <span>Mon Profil</span>
                </Breadcrumb.Item>
              )}

              {isCalendar && (
                <Breadcrumb.Item className={s.__item}>
                  <img src={Calendrier} alt="" width={25} />{" "}
                  <span>Calendrier</span>
                </Breadcrumb.Item>
              )}

              {isFAQ && (
                <Breadcrumb.Item className={s.__item}>
                  <span>Centre d’aide</span>
                  {seeDetails && <span>
                    <img src={ArrowRight} height={isMobile ? 10 : 15} style={{ marginRight: "5px", marginLeft: "5px" }}></img>
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => { setSeeDetails?.(false); /* setSeeCategories(false) */ }}
                    >
                      {actorFAQ}
                    </span>
                  </span>}
                  {seeDetails && <span /* onClick={() => setSeeCategories(!seeCategories)} */ style={{ color: "#7FB1B2" }}>
                    <img src={ArrowRight} height={isMobile ? 10 : 15} style={{ marginRight: "5px", marginLeft: "5px" }}></img>
                    {categoryFAQ}
                    {seeCategories && <img src={ArrowDown} height={isMobile ? 10 : 15} style={{ marginRight: "5px", marginLeft: "5px" }}></img>}
                  </span>}
                  {/* {seeDetails && seeCategories && <span>
                    {dataFAQ.length !== 1 && <div className={s.categoryBox}>
                      {dataFAQ && dataFAQ.filter((category: any) => category.title !== categoryFAQ).map((category: any, index: any) => (
                        <div
                          className={s.categoryText}
                          key={index}
                          onClick={() => {
                            setSeeDetails?.(true);
                            setCategoryData?.(category.data);
                            setCategoryDetailQuestion?.(category.data?.[0]?.question);
                            setCategoryDetailAnswer?.(category.data?.[0]?.answer);
                            setCategoryFAQ?.(category.title);
                            setSelectedquestion?.(0);
                            setSeeCategories(false);
                          }}
                        >
                          {category.title}
                        </div>
                      ))}
                    </div>}
                  </span>} */}
                </Breadcrumb.Item>
              )}

              {isGamification && (
                <Breadcrumb.Item className={s.__item}>
                  <img src={Gamification} alt="" width={25} />{" "}
                  <span>Gamification</span>
                </Breadcrumb.Item>
              )}

              {/* <Breadcrumb.Item
                className={s.__item}
                onClick={() => navigate(-1)}
              >
                <span>Page précédente</span>
              </Breadcrumb.Item> */}
            </Breadcrumb>
          </Col>

          <Col>
            <Row gutter={12}>
              {isBack && (
                <Col>
                  <Breadcrumb
                    style={{ lineHeight: "40px" }}
                    separator={
                      <span className={s.arrow}>
                        <RightOutlined color="#64B7AF" />
                      </span>
                    }
                  >
                    {!isProfil && <Breadcrumb.Item
                      className={s.__item}
                      onClick={() => {
                        pathBack ? navigate(pathBack) : navigate(-1);
                      }}
                    >
                      <span>
                        {" "}
                        <ArrowLeftOutlined
                          style={{ position: "relative", top: "1px" }}
                        />{" "}
                        {pathBack ? "Retour aux chapitres" : "Page précédente"}
                      </span>
                    </Breadcrumb.Item>}
                  </Breadcrumb>
                </Col>
              )}

              {isMycontent && (
                isTeacher && <Col>
                  {user?.isActive && user?.step === "completed" ? (
                    <Segmented
                      style={{
                        background: "#80B1B2",
                        borderRadius: "20px",
                        padding: "0.4em",
                      }}
                      defaultValue={
                        location.pathname === appRoutes.TEACHER_COURSES
                          ? "Contributeur"
                          : location.pathname === appRoutes.TEACHER_QUIZZ
                            ? "Contributeur"
                            : location.pathname === appRoutes.TEACHER_EXERCICES
                              ? "Contributeur"
                              : "Explorateur"
                      }
                      onChange={(event) => {
                        if (event === "Contributeur") {
                          navigate(appRoutes.TEACHER_COURSES);
                        }
                        if (event === "Explorateur") {
                          navigate(appRoutes.COURSESBYLEVELS);
                        }
                      }}
                      options={[
                        {
                          label: (
                            <span>
                              {" "}
                              <ListIcon
                                style={{
                                  position: "relative",
                                  width: "15px",
                                  height: "15px",
                                  top: "2.5px",

                                  display: "inline",
                                }}
                              />{" "}
                              Mode Contributeur
                            </span>
                          ),
                          value: "Contributeur",
                        },
                        {
                          label: <span>Mode Explorateur</span>,
                          value: "Explorateur",
                          icon: <AppstoreOutlined />,
                        },
                      ]}
                    />
                  ) : <Segmented
                    style={{
                      background: "#80B1B2",
                      borderRadius: "20px",
                      padding: "0.4em",
                    }}
                    defaultValue={"Explorateur"}
                    options={[
                      {
                        label: <span>Mode Explorateur</span>,
                        value: "Explorateur",
                        icon: <AppstoreOutlined />,
                      },
                    ]}
                  />}
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      </Container> : <Container>
        <Row justify="space-between">
          <Col>
            <Breadcrumb
              style={{ lineHeight: "40px" }}
              separator={
                <span className={s.arrow}>
                  <RightOutlined color="#64B7AF" />
                </span>
              }
            >
              <Breadcrumb.Item
                onClick={() => {
                  navigate(isParent ? appRoutes.PARENT_DASHBOARD : appRoutes.ORGANISM_DASHBOARD);
                }}
                className={s.__item}
              >
                <img src={HomeIcon} height={15} style={{ position: "relative", top: "-2px" }} />
              </Breadcrumb.Item>

              {isStudents && (
                <Breadcrumb.Item className={s.__item} onClick={() => {
                  navigate(appRoutes.ORGANISM_DASHBOARD);
                }}>
                  <img src={students} alt="" width={25} />{" "}
                  <span>Mes élèves</span>
                </Breadcrumb.Item>
              )}

              {isClassroom && (
                <Breadcrumb.Item className={s.__item} onClick={() => {
                  navigate(appRoutes.ORGANISM_CLASSES);
                }}>
                  <img src={Classes} alt="" width={25} />{" "}
                  <span>Mes Classes</span>
                </Breadcrumb.Item>
              )}

              {isTeachers && (
                <Breadcrumb.Item className={s.__item} onClick={() => {
                  navigate(appRoutes.ORGANISM_TEACHERS);
                }}>
                  <img src={Teacher} alt="" width={25} />{" "}
                  <span>Annuaire des profs</span>
                </Breadcrumb.Item>
              )}

              {isWallet && (
                <Breadcrumb.Item className={s.__item}>
                  <img src={Wallet} alt="" width={25} />{" "}
                  <span>Portefeuille</span>
                </Breadcrumb.Item>
              )}

              {isFAQ && (
                <Breadcrumb.Item className={s.__item}>
                  <span>Centre d’aide</span>
                  {seeDetails && <span>
                    <img src={ArrowRight} height={isMobile ? 10 : 15} style={{ marginRight: "5px", marginLeft: "5px" }}></img>
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => { setSeeDetails?.(false); /* setSeeCategories(!seeCategories) */ }}
                    >
                      {actorFAQ}
                    </span>
                  </span>}
                  {seeDetails && <span /* onClick={() => setSeeCategories(!seeCategories)} */ style={{ color: "#7FB1B2" }}>
                    <img src={ArrowRight} height={isMobile ? 10 : 15} style={{ marginRight: "5px", marginLeft: "5px" }}></img>
                    {categoryFAQ}
                    {seeCategories && <img src={ArrowDown} height={isMobile ? 10 : 15} style={{ marginRight: "5px", marginLeft: "5px" }}></img>}
                  </span>}
                  {/* {seeDetails && seeCategories && <span>
                    {dataFAQ.length !== 1 && <div className={s.categoryBox}>
                      {dataFAQ && dataFAQ.filter((category: any) => category.title !== categoryFAQ).map((category: any, index: any) => (
                        <div
                          className={s.categoryText}
                          key={index}
                          onClick={() => {
                            setSeeDetails?.(true);
                            setCategoryData?.(category.data);
                            setCategoryDetailQuestion?.(category.data?.[0]?.question);
                            setCategoryDetailAnswer?.(category.data?.[0]?.answer);
                            setCategoryFAQ?.(category.title);
                            setSelectedquestion?.(0);
                            setSeeCategories(!seeCategories);
                          }}
                        >
                          {category.title}
                        </div>
                      ))}
                    </div>}
                  </span>} */}
                </Breadcrumb.Item>
              )}

              {isGamification && (
                <Breadcrumb.Item className={s.__item}>
                  <img src={Gamification} alt="" width={25} />{" "}
                  <span>Gamification</span>
                </Breadcrumb.Item>
              )}

            </Breadcrumb>
          </Col>
          <Col>
            <Row gutter={12}>
              {isBack && (
                <Col>
                  <Breadcrumb
                    style={{ lineHeight: "40px" }}
                    separator={
                      <span className={s.arrow}>
                        <RightOutlined color="#64B7AF" />
                      </span>
                    }
                  >
                    {!isProfil && <Breadcrumb.Item
                      className={s.__item}
                      onClick={() => {
                        pathBack ? navigate(pathBack) : navigate(-1);
                      }}
                    >
                      <span>
                        {" "}
                        <ArrowLeftOutlined
                          style={{ position: "relative", top: "1px" }}
                        />{" "}
                        {pathBack ? "Retour aux chapitres" : "Page précédente"}
                      </span>
                    </Breadcrumb.Item>}
                  </Breadcrumb>
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      </Container>
      }
    </div>
  );
};

export default Breadcrumbs;
